const REHAB = 'rehab';
const IPPS = 'ipps'; // acute
const PSYCH = 'psych';
const LTCH = 'ltch';
const OPPS = 'opps';
const PFS = 'prof';
const ESRD = 'dialysis';
const HH = 'hh';
const SNF = 'snf';
const FQHC = 'fqhc';

export {
    REHAB,
    IPPS,
    PSYCH,
    LTCH,
    OPPS,
    PFS,
    ESRD,
    HH,
    SNF,
    FQHC
};